<script setup>
import VueTagsInput from '@sipec/vue3-tags-input';

import {computed, onMounted, ref} from 'vue';


const props = defineProps({
    filterId: { type: String, required: true },
    label:    { type: String, required: true },
    modelValue: { type: Array, default: [] },
});

const emit = defineEmits(['update:modelValue']);

const localValue = ref(props.modelValue);
const localTags = ref([]);
const tags = ref([]);
const tag = ref('');
const tagsComponent = ref(null);

const filteredTags = computed(() => {
    return tags.value.filter(i => {
        return i.text.toLowerCase().indexOf(tag.value.toLowerCase()) !== -1;
    });
})

const onInput = (newTags) => {
    localValue.value = newTags;
    emit('update:modelValue', localValue.value.map(t => t.text).join(' '));
};

const clear = () => {
    localValue.value = null;
    emit('update:modelValue', null);
};

const setTag = (_tag) => {
    localTags.value = [_tag]
}

onMounted(() => {
    axios.get('/training-tags', {
        params: {
            used: 1
        },
    }).then(response => {
        tags.value = response.data.data.map(function(tag){ return {'text': tag.name}});
    }).catch(() => {
    }).finally(() => {
    });

    const input = tagsComponent.value && tagsComponent.value.$el.querySelector('.ti-input')
    if (input) {
        input.classList.add('input')
    }
})

defineExpose({ clear, setTag });
</script>

<template>
    <b-field :label="label" custom-class="mb-3">
        <VueTagsInput
            :id="filterId"
            ref="tagsComponent"
            v-model="tag"
            :tags="localTags"
            :placeholder="$t('filters.tags_input_placeholder')"
            :autocomplete-items="filteredTags"
            @tags-changed="onInput"
            :add-on-key="[188, 13]"
        />
    </b-field>
</template>
